import {
  CreateItemGqlQuery,
  CreateItemGqlStatus,
  DeleteItemGqlQuery,
  DeleteItemGqlStatus,
  FetchItemsCacheKey,
  ItemGqlError,
  TrackTimeInItemGqlQuery,
  UpdateItemCacheKeys,
  UpdateItemGqlQuery,
  UpdateItemGqlStatus
} from '../../../types';
import {
  UpdateItemsGqlError,
  UpdateItemsGqlQuery,
  UpdateItemsGqlStatus
} from '../../../types/updateItemsTypes';
import {
  CreateItemsGqlQuery,
  CreateItemsGqlStatus
} from '../../../types/createItemsTypes';

export * from './projectsFields';
export * from './fetchProjectsTypes';
export * from './createInvoiceFromProformaSettings.types';

export type CreateProjectGqlQuery = CreateItemGqlQuery;
export type CreateProjectInTeamGqlQuery = CreateItemGqlQuery;
export type CreateProjectTasksGqlQuery = CreateItemGqlQuery;
export type CreateProjectsInTeamGqlQuery = CreateItemsGqlQuery;
export type UpdateProjectGqlQuery = UpdateItemGqlQuery;
export type DeleteProjectGqlQuery = DeleteItemGqlQuery;
export type DownloadProjectResultsGqlQuery = UpdateItemGqlQuery;
export type DownloadAllProjectResultsGqlQuery = UpdateItemGqlQuery;
export type TrackTimeInProjectGqlQuery = TrackTimeInItemGqlQuery;
export type SubmitFileAttachmentsToProjectGqlQuery = CreateItemGqlQuery;

export type CreateProjectGqlStatus = CreateItemGqlStatus;
export type CreateProjectInTeamGqlStatus = CreateItemGqlStatus;
export type CreateProjectTasksGqlStatus = CreateItemGqlStatus;
export type CreateProjectsInTeamGqlStatus = CreateItemsGqlStatus;
export type UpdateProjectGqlStatus = UpdateItemGqlStatus;
export type DeleteProjectGqlStatus = DeleteItemGqlStatus;
export type DownloadProjectResultsGqlStatus = UpdateItemGqlStatus;
export type DownloadAllProjectResultsGqlStatus = UpdateItemGqlStatus;
export type SubmitFileAttachmentsToProjectGqlStatus = CreateItemGqlStatus;
export type ProjectGqlError = ItemGqlError;

export type inviteUsersToProjectsGqlQuery = UpdateItemsGqlQuery;
export type inviteUsersToProjectsGqlStatus = UpdateItemsGqlStatus;
export type inviteUsersToProjectsGqlError = UpdateItemsGqlError;

export type CreateProjectsBillsGqlStatus = CreateItemGqlStatus;
export type CreateProjectsBillsGqlError = ItemGqlError;
export type CreateProjectsBillsGqlQuery = CreateItemGqlQuery;
export type CreateProjectsBillsCacheKey = FetchItemsCacheKey;
export type CreateProjectsBillsCacheKeys = CreateProjectsBillsCacheKey[];

export type UpdateProjectCacheKeys = UpdateItemCacheKeys;

export type MuteProjectTasksNotificationsGqlStatus = UpdateItemsGqlStatus;
export type MuteProjectTasksNotificationsCacheKeys = UpdateItemCacheKeys;
export type MuteProjectTasksNotificationsGqlError = UpdateItemsGqlError;
export type MuteProjectTasksNotificationsGqlQuery = UpdateItemsGqlQuery;

export type UnmuteProjectTasksNotificationsGqlStatus = UpdateItemsGqlStatus;
export type UnmuteProjectTasksNotificationsCacheKeys = UpdateItemCacheKeys;
export type UnmuteProjectTasksNotificationsGqlError = UpdateItemsGqlError;
export type UnmuteProjectTasksNotificationsGqlQuery = UpdateItemsGqlQuery;

export type ProjectCacheSyncGqlQuery = UpdateItemGqlQuery;
export type ProjectCacheSyncGqlStatus = UpdateItemGqlStatus;
export type ProjectCacheSyncGqlError = ItemGqlError;
export type ProjectCacheSyncGqlErrors = ProjectCacheSyncGqlError[];
export type ProjectCacheSyncCacheKeys = UpdateItemCacheKeys;
